module.exports = __webpack_public_path__ + "img/FullAnimation2.3db545f1.png";